import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class NavigationStore {
  selectedSideNavItem: string = '';
  isPopUpNotifierOpen: boolean = false;

  constructor() {
    makeObservable(this, {
      selectedSideNavItem: observable,
      setSelectedSideNavItem: action,
      removeSelectedSideNavItem: action,
      clearNavigationStore: action,

      isPopUpNotifierOpen: observable,
      handleOpenPopUpNotifier: action,
    });
    makePersistable(this, {
      name: 'NavigationStore',
      properties: ['selectedSideNavItem', 'isPopUpNotifierOpen'],
      storage: window.localStorage,
    });
  }

  setSelectedSideNavItem(itemName: string) {
    this.selectedSideNavItem = itemName;
  }

  removeSelectedSideNavItem() {
    this.selectedSideNavItem = '';
  }

  clearNavigationStore() {
    this.selectedSideNavItem = '';
    this.isPopUpNotifierOpen = false;
  }

  handleOpenPopUpNotifier(isPopUpNotifierOpen: boolean) {
    this.isPopUpNotifierOpen = isPopUpNotifierOpen;
  }
}
export default NavigationStore;
